import { render, staticRenderFns } from "./BaseCaption.vue?vue&type=template&id=2d56daa9&scoped=true"
import script from "./BaseCaption.vue?vue&type=script&lang=js"
export * from "./BaseCaption.vue?vue&type=script&lang=js"
import style0 from "./BaseCaption.vue?vue&type=style&index=0&id=2d56daa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d56daa9",
  null
  
)

export default component.exports